import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { motion } from "framer-motion";
import Sesion from "./components/Sesion";
import { sesionIniciada, sesionIniciadaFamilia } from './controllers/configuracionFirebase';
import { Toaster } from 'react-hot-toast';
import Loading from './components/Loading';
import WebFont from 'webfontloader';
import { fetchData } from './controllers/tiempoLimiteInscripcion';

function App() {

  const [ usuario, setUsuario ] = useState();
  const [ usuarioFamilia, setUsuarioFamilia ] = useState();
  const [ fechaGoogle, setFechaGoogle ] = useState();
  const [ isLoading, setIsLoading ] = useState(true);

  useEffect(() => {
    sesionIniciada(setUsuario);
    sesionIniciadaFamilia(setUsuarioFamilia);

    WebFont.load({
      google: {
        families: [
          "Abril Fatface",
          "IBM Plex Mono",
          "Acme",
          "Yeseva One",
          "Fira Sans Extra Condensed",
          "Poppins",
          "Merriweather Sans",
          "Bebas Neue",
          "EB Garamond",
          "Alkatra",
          "Calistoga",
          "Oleo Script",
          "Libre Baskerville",
          "Lora",
          'Anton SC',
          'Gothic A1',
          "Winky Sans"
        ]
      }
    });

    setIsLoading(false);
    fetchData(setFechaGoogle);
  }, [])

  return (
    <div className="App"> 
      {isLoading ?(
        <Loading/>
      ):(
      <Router>
        <motion.nav
          className={`navbar navbar-expand-lg shadow-sm ${!usuario && 'w-100 position-absolute top-0'}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 12%, rgba(0, 212, 255, 1) 100%)'}}
        >
          <div className="container-fluid">
            <div className='w-100 d-flex justify-content-between align-items-center'>
              <img
                className='img-barra-menu'
                style={{ maxWidth: "40px" }}
                src={require("./img/img-logo-swimmingt.webp")}
                alt="logo prowebsports"
              />
              <span className='text-light' id="reloj" style={{fontFamily: 'Lora', fontSize: '25px'}}></span>
            </div>
          </div>
        </motion.nav>
        <Routes>
          <Route
            path="/*"
            element={
              <Sesion usuario={usuario} usuarioFamilia={usuarioFamilia} fechaGoogle={fechaGoogle}/>
            }
          />
        </Routes>
      </Router>
      )}
      <Toaster containerStyle={{textAlign: 'start'}}/>
    </div>
  );
}

export default App;